import { useTranslation } from "react-i18next";import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const SOLUTIONS = [
{
  title: 'Property Managers',
  subtitle: 'Multi-building operations',
  details: ['Automated billing', 'Tenant management', 'Financial reporting', 'Team collaboration'],
  image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop'
},
{
  title: 'Property Owners',
  subtitle: 'Portfolio tracking',
  details: ['Revenue transparency', 'Digital contracts', 'Commission management', 'Maintenance approvals'],
  image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=2073&auto=format&fit=crop'
},
{
  title: 'Real Estate Agencies',
  subtitle: 'Multi-client management',
  details: ['Booking & waitlist', 'White-label branding', 'Advanced reporting', 'Client portals'],
  image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2069&auto=format&fit=crop'
}];


export default function Solutions() {const { t } = useTranslation();
  const { isDarkMode } = useTheme();

  return (
    <section id="solutions" className="py-24 lg:py-32">
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <p className="text-[11px] font-medium text-red-600 tracking-[3px] uppercase mb-16 flex items-center gap-3">
                    <span className="w-6 h-px bg-red-700" />
                    {t("solutions")}
                </p>
                
                <h2
          className={`${isDarkMode ? 'text-white' : 'text-zinc-900'} font-light leading-[1.1] mb-20`}
          style={{ fontFamily: "'Instrument Serif', Georgia, serif", fontSize: 'clamp(2.5rem,5vw,4rem)' }}>
                    {t("built_for_every_property_professional")}
                
        </h2>

                <div className="grid md:grid-cols-3 gap-6">
                    {SOLUTIONS.map((solution, index) =>
          <div
            key={index}
            className="relative aspect-[3/4] overflow-hidden group cursor-pointer">
            
                            <img
              src={solution.image}
              alt={solution.title}
              className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105" />
            
                            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent group-hover:from-black/90 group-hover:via-black/60 transition-all duration-500" />
                            
                            <div className="absolute bottom-0 left-0 right-0 p-8">
                                <p className="text-white/60 text-xs font-light tracking-wider uppercase mb-2">
                                    {solution.subtitle}
                                </p>
                                <h3
                className="text-white text-2xl lg:text-3xl font-light mb-6"
                style={{ fontFamily: "'Instrument Serif', Georgia, serif" }}>
                
                                    {solution.title}
                                </h3>
                                
                                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-500 space-y-2">
                                    {solution.details.map((detail, i) =>
                <div key={i} className="flex items-center gap-2">
                                            <div className="w-1 h-1 bg-red-600 rounded-full" />
                                            <span className="text-white/80 text-sm font-light">{detail}</span>
                                        </div>
                )}
                                </div>
                            </div>
                        </div>
          )}
                </div>
            </div>
        </section>);

}